"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityDamage = void 0;
const DamageType_1 = require("./enums/DamageType");
class AbilityDamage {
    constructor(primaryAttribute, type, power) {
        this.primaryAttribute = primaryAttribute;
        this.type = type;
        this.power = power;
    }
}
exports.AbilityDamage = AbilityDamage;
AbilityDamage.Focus = (type, power) => new AbilityDamage("Focus", DamageType_1.DamageType[type], power);
AbilityDamage.Power = (type, power) => new AbilityDamage("Power", DamageType_1.DamageType[type], power);
